import React from "react";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";
import { SelectField, TextField } from "@syos-music/form";

import { Grid, MenuItem } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const MUTATION = gql`
  mutation (
    $orderId: ID!
    $trackingId: String!
    $carrier: OrderShipment_Custom_Carrier!
  ) {
    CreateOrderShipmentCustom(
      orderId: $orderId
      trackingId: $trackingId
      carrier: $carrier
    ) {
      order {
        id
      }
    }
  }
`;

export default function OrderShipmentCustomForm({ order, onSubmitted }) {
  const [createOrderShipmentCustom] = useMutation(MUTATION);

  return (
    <Form
      noValidate
      mutators={{ ...arrayMutators }}
      onSubmit={({ trackingId, carrier }) =>
        createOrderShipmentCustom({
          variables: {
            orderId: order.id,
            trackingId,
            carrier,
          },
        })
          .then(() => {
            onSubmitted();
          })
          .catch(() => true)
      }
      initialValues={{ carrier: "LETTRE_SUIVIE" }}
      keepDirtyOnReinitialize
    >
      {({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid container justifyContent="flex-end">
            <Grid item xs={12} md={6}>
              <TextField name="trackingId" required label="Tracking ID" />
            </Grid>

            <Grid item xs={12} md={6}>
              <SelectField name="carrier" required label="Transporteur">
                <MenuItem value="COLISSIMO">Colissimo</MenuItem>
                <MenuItem value="DELIVENGO">Delivengo</MenuItem>
                <MenuItem value="DHL">DHL Express</MenuItem>
                <MenuItem value="FEDEX">FedEx</MenuItem>
                <MenuItem value="LETTRE_SUIVIE">Lettre suivie</MenuItem>
                <MenuItem value="UPS">UPS</MenuItem>
              </SelectField>
            </Grid>

            <Grid item>
              <LoadingButton type="submit" loading={submitting}>
                Valider
              </LoadingButton>
            </Grid>
          </Grid>
        </form>
      )}
    </Form>
  );
}
